import BanWorkerModal from './BanWorkerModal';

export default BanWorkerModal;
